import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FloatingToggle = ({ viewMode, setViewMode }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleModeChange = (newMode) => {
    setViewMode(newMode);
  };

  return (
    <div className="floating-toggle">
      <div
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          height: "100%",
          width: "30px",
          backgroundColor: isOpen ? "rgba(0,0,0,0.1)" : "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div
          style={{
            fontSize: "18px",
            transform: isOpen ? "rotate(0deg)" : "rotate(-180deg)",
            transition: "transform 0.3s ease",
          }}
        >
          ➤
        </div>
      </div>

      {isOpen && (
        <div className="toggle-content">
          <strong>Administrateur Akanthas</strong>
          <p>Choisir mon mode d'affichage :</p>
          <div className="toggle-switch">
            <span style={{ fontSize: 13 }}>Mode client</span>
            <div
              className={`switch ${viewMode === "admin" ? "admin" : "client"}`}
              onClick={() =>
                handleModeChange(viewMode === "client" ? "admin" : "client")
              }
            >
              <div className="knob" />
            </div>
            <span style={{ fontSize: 13 }}>Mode admin</span>
          </div>
          <Link className="floating-toggle-link" to="/digitaltwins">
            {t("Digital Twins")}
          </Link>
        </div>
      )}
    </div>
  );
};

export default FloatingToggle;
